export default {
  SET_USER_GEO_LOCATION: 'SET_USER_GEO_LOCATION',
  CLEAR_GEO_LOCATION: 'CLEAR_GEO_LOCATION'
};
